import { compose } from 'redux';

import type { TrackingState } from '../trackingStore';

const selectRouteHistoryDomain = (state: TrackingState) => state.routesHistory;

export const selectVehicleRoutes = compose(
  (state) => state.vehicleRoutesWebData,
  selectRouteHistoryDomain
);

export default selectVehicleRoutes;
